<script lang="ts">

    import { redirectTo } from "../scripts/router1";
    import { idPagePartenaire } from "../scripts/router2";
    import { storeEcosystemId, EcosystemInterface } from "../scripts/ecosystem";

    export let props: EcosystemInterface;

    /**
     * selectEcosystem
     * @param id
     */
    function selectEcosystem(id: number) {
        storeEcosystemId.set(id);
        redirectTo(idPagePartenaire, "?id="+id);
    }
    
</script>

<style lang="scss">

	.tileecosystem {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 30px 30px 30px 30px;
        background-color: $color_white;
        box-shadow: 0px 0px 4px $color_text;
        border-radius: 10px;
        &__pelican {
            border: 2px solid $color_primary;
        }
        &__aigle {
            border: 2px solid $color_primary;
        }
        &__colibri {
            border: 2px solid $color_primary;
        }
        &__img {
            width: 150px;
            height: 150px;
            padding: 15px 15px 15px 15px;
            cursor: pointer;
            &__nolink {
                cursor: default;
            }
        }
	}

    @include large {
        .tileecosystem {
            &__img {
                transition: all;
                transition-duration: 0.5s;
                &:hover {
                    transform: scale(0.9);
                }
            }
        }
    }

</style>

<div class="tileecosystem" class:tileecosystem__pelican={props.id_partner_level == 1} class:tileecosystem__aigle={props.id_partner_level == 2 } class:tileecosystem__colibri={props.id_partner_level == 3}>
    {#if props.id_partner_level < 99 && props.published}
    <img class="tileecosystem__img" title={props.name} alt={props.name} src="../assets/images/ecosystem/{props.id}_{props.logo}" on:click={() => selectEcosystem(props.id)} on:keydown={() => selectEcosystem(props.id)}>
    {:else}
        {#if (props.website != undefined && props.website != "")}
            <a href={props.website} target="_blank">
                <img class="tileecosystem__img" title={props.website} alt={props.website} src="../assets/images/ecosystem/{props.id}_{props.logo}">
            </a>
        {:else}
            <img class="tileecosystem__img tileecosystem__img__nolink" title={props.website} alt={props.website} src="../assets/images/ecosystem/{props.id}_{props.logo}">
        {/if}
    {/if}
    <div class="tileecosystem__title">{props.name}</div>
</div>
